import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { Provider } from 'react-redux';
import { store } from './store';
import { ModalProvider } from './Components/Modal/ModalContext';
import { TimeModalProvider } from './Components/TimeModal/TimeModalContext';
import { Tooltip } from 'react-tooltip';

import Index from './Pages/Index';
import IndexLayout from './Layouts/IndexLayout';
import Home from './Pages/Home';
import Account from './Pages/Account';
import EssentialDataModal from './Pages/EssentialDataModal';
import Inbox from './Pages/Inbox';
import LastCasesMessages from './Pages/LastCasesMessages';
import MembershipFees from './Pages/MembershipFees';
import Procedures from './Pages/Procedures';
import Applications from './Pages/Applications';
import ProposedCases from './Pages/ProposedCases';

import PageOfCase from './Pages/PageOfCase';
import PageOfDebtor from './Pages/PageOfDebtor';
import PageOfApplicant from './Pages/PageOfApplicant';
// import FileViewer from './Pages/FileViewer';

import EditCase from './Pages/EditCase';
import EditDebtor from './Pages/EditDebtor';
import EditApplicant from './Pages/EditApplicant';

import ViewFeedback from './Pages/ViewFeedback';
import Unloading from './Pages/Unloading';
import ProceduresEditor from './Pages/ProceduresEditor';
import Registers from './Pages/Registers';
import Users from './Pages/Users';
import Testing from './Pages/Testing';
import ActivityLogs from './Pages/ActivityLogs';
import AdditionalAdminSettings from './Pages/AdditionalAdminSettings';

import ChangePassword from './Pages/ChangePassword';
import Signature from './Pages/Signature';

import EmailAuthentication from './Pages/EmailAuthentication';

import Login from './Pages/Login';
import ResetPassword from './Pages/ResetPassword';
import Logout from './Components/Logout';
import Registration from './Pages/Registration';
import SendFeedbackPage from './Pages/SendFeedbackPage';
import TermsOfUse from './Pages/TermsOfUse';
import Policy from './Pages/Policy';

import Help from './Help/Help';
import NotFound from './Pages/NotFound';

import Header from './Components/Header';
import RouteTitleUpdater from './Components/RouteTitleUpdater';

import PublicRoute from './Components/PublicRoute';
import PrivateRoute from './Components/PrivateRoute';
import SuperProtectedRoute from './Components/SuperProtectedRoute';
import { NotificationsProvider } from './Components/Context/NotificationsCountContext';

import TopHeaderLayout from './Layouts/TopHeaderLayout';

const App = () => {
  const location = useLocation();

  const showHeaderOnRoutes = [
    '/home', '/account', '/membership-fees', '/procedures', '/applications',
    '/proposed-cases', '/last-cases-messages', '/add-new-case', '/change-case', '/add-new-debtor', '/change-debtor', 
    '/add-new-applicant', '/change-applicant', '/inbox', '/users',
    '/view-feedback', '/procedures-editor', '/registers', '/unloading', '/activity-log', '/additional-admin-settings',
    '/tstng', '/case', '/account', '/debtor', '/applicant', '/safety/signature'
  ];

  const shouldShowHeader = showHeaderOnRoutes.some(route =>
    location.pathname === route || location.pathname.startsWith(`${route}/`)
  );

  return (
    <Provider store={store}>
      <ModalProvider>
        <TimeModalProvider>
          <NotificationsProvider>
        <div className="App">
          <Tooltip id="icon-tooltip" className='tooltipText' />
          {shouldShowHeader && <Header />}
          <Routes>
            <Route path="/" element={<PublicRoute><IndexLayout /></PublicRoute>}>
                <Route index element={<Index />} />
            </Route>
            <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
            <Route path="/account" element={<PrivateRoute><Account /></PrivateRoute>} />
            <Route path="/essential-data" element={<PrivateRoute><EssentialDataModal /></PrivateRoute>} />
            <Route path="/inbox" element={<PrivateRoute><Inbox /></PrivateRoute>} />
            <Route path="/last-cases-messages" element={<PrivateRoute><LastCasesMessages /></PrivateRoute>} />
            <Route path="/membership-fees" element={<PrivateRoute><MembershipFees /></PrivateRoute>} />
            <Route path="/procedures" element={<PrivateRoute><Procedures /></PrivateRoute>} />
            <Route path="/applications" element={<PrivateRoute><Applications /></PrivateRoute>} />
            <Route path="/proposed-cases" element={<PrivateRoute><ProposedCases /></PrivateRoute>} />

            <Route path="/case/:id" element={<PrivateRoute><PageOfCase /></PrivateRoute>} />
            <Route path="/account/:id" element={<PrivateRoute><Account /></PrivateRoute>} />
            <Route path="/safety/signature/:id" element={<PrivateRoute><Signature /></PrivateRoute>} />
            <Route path="/debtor/:id" element={<PrivateRoute><PageOfDebtor /></PrivateRoute>} />
            <Route path="/applicant/:id" element={<PrivateRoute><PageOfApplicant /></PrivateRoute>} />
            {/* <Route path="/file/:id" element={<PrivateRoute><FileViewer /></PrivateRoute>} /> */}

            <Route path="/add-new-case" element={<PrivateRoute><EditCase action='add' /></PrivateRoute>} />
            <Route path="/change-case/:id" element={<PrivateRoute><EditCase action='change' /></PrivateRoute>} />
            <Route path="/add-new-debtor" element={<PrivateRoute><EditDebtor action='add' /></PrivateRoute>} />
            <Route path="/change-debtor/:id" element={<PrivateRoute><EditDebtor action='change' /></PrivateRoute>} />
            <Route path="/add-new-applicant" element={<PrivateRoute><EditApplicant action='add' /></PrivateRoute>} />
            <Route path="/change-applicant/:id" element={<PrivateRoute><EditApplicant action='change' /></PrivateRoute>} />

            <Route path="/view-feedback" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['АппаратСРО']}><ViewFeedback /></SuperProtectedRoute></PrivateRoute>} />
            <Route path="/unloading" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['АппаратСРО']}><Unloading /></SuperProtectedRoute></PrivateRoute>} />
            <Route path="/procedures-editor" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['АппаратСРО']}><ProceduresEditor /></SuperProtectedRoute></PrivateRoute>} />
            <Route path="/registers" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['АппаратСРО']}><Registers /></SuperProtectedRoute></PrivateRoute>} />
            <Route path="/users" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['АппаратСРО']}><Users /></SuperProtectedRoute></PrivateRoute>} />
            <Route path="/tstng" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['АппаратСРО']}><Testing /></SuperProtectedRoute></PrivateRoute>} />
            <Route path="/activity-log" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['АппаратСРО']}><ActivityLogs /></SuperProtectedRoute></PrivateRoute>} />
            <Route path="/additional-admin-settings" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['АппаратСРО']}><AdditionalAdminSettings /></SuperProtectedRoute></PrivateRoute>} />

            <Route path="/safety/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
            <Route path="/safety/signature" element={<PrivateRoute><Signature /></PrivateRoute>} />

            <Route path="/safety/email-authentication" element={<EmailAuthentication />} />

            <Route path="/auth/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/auth/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
            <Route path="/auth/registration" element={<PublicRoute><Registration /></PublicRoute>} />
            <Route path="/send-feedback" element={<SendFeedbackPage />} />
            <Route path="/auth/logout" element={<Logout />} />

            <Route path="/legal" element={<TopHeaderLayout />}>
                <Route path="terms-of-use" element={<TermsOfUse />} />
                <Route path="privacy-policy" element={<Policy />} />
            </Route>
            <Route path="/help" element={<TopHeaderLayout />}>
                <Route index element={<Help />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <RouteTitleUpdater/>
        </NotificationsProvider>
        </TimeModalProvider>
      </ModalProvider>
    </Provider>
  );
};

export default App;
